import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, renderList as _renderList, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "question" }
const _hoisted_2 = { style: {"white-space":"break-spaces"} }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"16px"} }, "Toelichting", -1)

import { questionnaireStore } from '@/stores/questionnaire'
import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Question',
  setup(__props) {

const defaultRating = ref(['Zeer slecht', 'Slecht', 'Normaal', 'Goed', 'Zeer goed'])
const ratingLength = ref(5)

function onChecked (checkedValues: string[]) : void {
  if (questionnaireStore().openAnswerChecked) {
    questionnaireStore().updateResult([...checkedValues, 'Anders: ' + questionnaireStore().customAnswer])
  } else {
    questionnaireStore().updateResult(checkedValues)
  }
}

function onRadioChange (e: Event & { target: HTMLInputElement }) : void {
  questionnaireStore().updateResult([e.target.value])
}

function updateEventValue (e: Event & { target: HTMLInputElement }) : void {
  questionnaireStore().updateResult([e.target.value])
}

function handleCustomAnswerChecked () : void {
  questionnaireStore().openAnswerChecked = !questionnaireStore().openAnswerChecked
  updateCustomAnswer()
}

function handleCustomAnswer () : void {
  updateCustomAnswer()
}

function updateCustomAnswer () : void {
  const answerArray:string[] = questionnaireStore().questionResult as string[]
  const index = answerArray.findIndex(a => a.includes('Anders:'))
  if (index >= 0) {
    if (!questionnaireStore().openAnswerChecked) {
      answerArray.splice(index, 1)
      questionnaireStore().customAnswer = ''
    } else {
      answerArray[index] = 'Anders: ' + questionnaireStore().customAnswer
    }
  } else {
    answerArray.push('Anders: ' + questionnaireStore().customAnswer)
  }
  questionnaireStore().results[questionnaireStore().currentQuestionnaireIndex].answers[questionnaireStore().currentQuestionIndex].answer = answerArray
}

function getRating (answers:string[]) {
  const rating:string[] = answers.length < 1 ? defaultRating.value : answers
  const tooltips:string[] = []

  for (let i = 0; i < ratingLength.value; i++) {
    tooltips[i] = ''
  }

  tooltips[0] = rating[0]
  tooltips[ratingLength.value - 1] = rating[rating.length - 1]

  return tooltips
}

function updateSingleValue (value:number) {
  questionnaireStore().updateResult([value])
}

return (_ctx: any,_cache: any) => {
  const _component_a_checkbox_group = _resolveComponent("a-checkbox-group")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_rate = _resolveComponent("a-rate")!
  const _component_a_textarea = _resolveComponent("a-textarea")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, _toDisplayString(_unref(questionnaireStore)().currentQuestion.phrase), 1),
    (_unref(questionnaireStore)().currentQuestion.type === 'multiple')
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, "Er zijn meerdere antwoorden mogelijk."))
      : _createCommentVNode("", true),
    (!_unref(questionnaireStore)().currentQuestion.required && _unref(questionnaireStore)().currentQuestion.required !== undefined)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, "Deze vraag is optioneel."))
      : _createCommentVNode("", true),
    (_unref(questionnaireStore)().currentQuestion.type === 'multiple')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          (_unref(questionnaireStore)().currentQuestion.answers.length > 0)
            ? (_openBlock(), _createBlock(_component_a_checkbox_group, {
                key: 0,
                value: _unref(questionnaireStore)().results[_unref(questionnaireStore)().currentQuestionnaireIndex].answers[_unref(questionnaireStore)().currentQuestionIndex].answer,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(questionnaireStore)().results[_unref(questionnaireStore)().currentQuestionnaireIndex].answers[_unref(questionnaireStore)().currentQuestionIndex].answer) = $event)),
                options: _unref(questionnaireStore)().currentQuestion.answers.filter(a => a !== 'Anders'),
                onChange: onChecked
              }, null, 8, ["value", "options"]))
            : _createCommentVNode("", true),
          _hoisted_5,
          (_unref(questionnaireStore)().currentQuestion.answers.indexOf('Anders') >= 0)
            ? (_openBlock(), _createBlock(_component_a_checkbox, {
                key: 1,
                checked: _unref(questionnaireStore)().openAnswerChecked,
                onChange: handleCustomAnswerChecked
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Anders, namelijk: "),
                  (_unref(questionnaireStore)().openAnswerChecked)
                    ? (_openBlock(), _createBlock(_component_a_input, {
                        key: 0,
                        value: _unref(questionnaireStore)().customAnswer,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_unref(questionnaireStore)().customAnswer) = $event)),
                        onChange: handleCustomAnswer,
                        allowClear: ""
                      }, null, 8, ["value"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["checked"]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    (_unref(questionnaireStore)().currentQuestion.type === 'selection')
      ? (_openBlock(), _createBlock(_component_a_radio_group, {
          key: 3,
          value: _unref(questionnaireStore)().results[_unref(questionnaireStore)().currentQuestionnaireIndex].answers[_unref(questionnaireStore)().currentQuestionIndex].answer[0],
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_unref(questionnaireStore)().results[_unref(questionnaireStore)().currentQuestionnaireIndex].answers[_unref(questionnaireStore)().currentQuestionIndex].answer[0]) = $event)),
          onChange: onRadioChange
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(questionnaireStore)().currentQuestion.answers, (answer, index) => {
              return (_openBlock(), _createBlock(_component_a_radio, {
                style: { display: 'block', height: '30px', lineHeight: '30px' },
                value: index,
                key: index
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(answer), 1)
                ]),
                _: 2
              }, 1032, ["value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["value"]))
      : _createCommentVNode("", true),
    (_unref(questionnaireStore)().currentQuestion.type === 'rating')
      ? (_openBlock(), _createBlock(_component_a_rate, {
          key: 4,
          value: _unref(questionnaireStore)().results[_unref(questionnaireStore)().currentQuestionnaireIndex].answers[_unref(questionnaireStore)().currentQuestionIndex].answer[0],
          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_unref(questionnaireStore)().results[_unref(questionnaireStore)().currentQuestionnaireIndex].answers[_unref(questionnaireStore)().currentQuestionIndex].answer[0]) = $event)),
          count: getRating(_unref(questionnaireStore)().questionAnswers).length,
          tooltips: getRating(_unref(questionnaireStore)().currentQuestion.answers),
          onChange: updateSingleValue
        }, null, 8, ["value", "count", "tooltips"]))
      : _createCommentVNode("", true),
    (_unref(questionnaireStore)().currentQuestion.type === 'rating+')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
          _createVNode(_component_a_rate, {
            value: _unref(questionnaireStore)().results[_unref(questionnaireStore)().currentQuestionnaireIndex].answers[_unref(questionnaireStore)().currentQuestionIndex].answer[0],
            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_unref(questionnaireStore)().results[_unref(questionnaireStore)().currentQuestionnaireIndex].answers[_unref(questionnaireStore)().currentQuestionIndex].answer[0]) = $event)),
            count: getRating(_unref(questionnaireStore)().questionAnswers).length,
            tooltips: getRating(_unref(questionnaireStore)().currentQuestion.answers),
            onChange: updateSingleValue
          }, null, 8, ["value", "count", "tooltips"]),
          _hoisted_6,
          _createVNode(_component_a_textarea, {
            disabled: _unref(questionnaireStore)().results[_unref(questionnaireStore)().currentQuestionnaireIndex].answers[_unref(questionnaireStore)().currentQuestionIndex].answer[0] <= 0 || _unref(questionnaireStore)().results[_unref(questionnaireStore)().currentQuestionnaireIndex].answers[_unref(questionnaireStore)().currentQuestionIndex].answer.length === 0,
            value: _unref(questionnaireStore)().results[_unref(questionnaireStore)().currentQuestionnaireIndex].answers[_unref(questionnaireStore)().currentQuestionIndex].answer[1],
            "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_unref(questionnaireStore)().results[_unref(questionnaireStore)().currentQuestionnaireIndex].answers[_unref(questionnaireStore)().currentQuestionIndex].answer[1]) = $event)),
            "auto-size": { minRows: 3, maxRows: 5 }
          }, null, 8, ["disabled", "value"])
        ], 64))
      : _createCommentVNode("", true),
    (_unref(questionnaireStore)().currentQuestion.type === 'open')
      ? (_openBlock(), _createBlock(_component_a_textarea, {
          key: 6,
          value: _unref(questionnaireStore)().results[_unref(questionnaireStore)().currentQuestionnaireIndex].answers[_unref(questionnaireStore)().currentQuestionIndex].answer[0],
          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_unref(questionnaireStore)().results[_unref(questionnaireStore)().currentQuestionnaireIndex].answers[_unref(questionnaireStore)().currentQuestionIndex].answer[0]) = $event)),
          "auto-size": { minRows: 3, maxRows: 5 },
          onChange: updateEventValue
        }, null, 8, ["value"]))
      : _createCommentVNode("", true)
  ]))
}
}

})